export const updateFavicon = (faviconUrl) => {
    if (!faviconUrl) return;
    
    const existingLinks = document.querySelectorAll("link[rel*='icon']");
    existingLinks.forEach(link => link.remove());
    
    const link = document.createElement('link');
    link.rel = 'shortcut icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
    
    const link2 = document.createElement('link');
    link2.rel = 'icon';
    link2.type = 'image/x-icon';
    link2.href = faviconUrl;
    document.head.appendChild(link2);
};